// Author thq
// Date 2024-05-31 11:22:45

class EmSppLocation {
    constructor({
                    id = null,
                    sid = '',
                    pkGroup = '',
                    pkOrg = '',
                    code = '',
                    name = '',
                    type = '',
                    parentId = '',
                    warehouseKeeper = '',
                    seq = '',
                    remark = '',
                    externalId = ''
                }
                    = {}) {
        this.id = id;
        this.sid = sid;
        this.pkGroup = pkGroup;
        this.pkOrg = pkOrg;
        this.code = code;
        this.name = name;
        this.type = type;
        this.parentId = parentId;
        this.warehouseKeeper = warehouseKeeper;
        this.seq = seq;
        this.remark = remark;
        this.externalId = externalId;
    }
}

function newEntity() {
    return new EmSppLocation();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.spareparts.emSppLocation.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'code',
            label: 'label.em.spareparts.emSppLocation.grid.code',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'name',
            label: 'label.em.spareparts.emSppLocation.grid.name',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'type',
            label: 'label.em.spareparts.emSppLocation.grid.type',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '库房'},
                    {value: '2', text: '库位'}
                ]
            }
        },
        {
            key: 'parentName',
            label: 'label.em.spareparts.emSppLocation.grid.parentName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'level',
            label: 'label.em.spareparts.emSppLocation.grid.level',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'nodeCode',
            label: 'label.em.spareparts.emSppLocation.grid.nodeCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'seq',
            label: 'label.em.spareparts.emSppLocation.grid.seq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouseKeeper',
            label: 'label.em.spareparts.emSppLocation.grid.warehouseKeeper',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.em.spareparts.emSppLocation.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    sidFilter: '',
    pkGroupFilter: '',
    pkOrgFilter: '',
    codeFilter: '',
    nameFilter: '',
    typeFilter: '',
    parentIdFilter: '',
    parentNameFilter: '',
    levelFilter: '',
    nodeCodeFilter: '',
    seqFilter: '',
    externalIdFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'codeFilter',
        label: 'label.em.spareparts.emSppLocation.filter.code',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'nameFilter',
        label: 'label.em.spareparts.emSppLocation.filter.name',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'typeFilter',
        label: 'label.em.spareparts.emSppLocation.filter.type',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '库房'},
                {value: '2', text: '库位'}
            ]
        }
    },
    {
        key: 'parentNameFilter',
        label: 'label.em.spareparts.emSppLocation.filter.parentName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'code',
        label: 'label.em.spareparts.emSppLocation.entity.code',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'name',
        label: 'label.em.spareparts.emSppLocation.entity.name',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            , required: true
        }
    },
    {
        key: 'type',
        label: 'label.em.spareparts.emSppLocation.entity.type',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , required: true
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '库房'},
                {value: '2', text: '库位'}
            ]
        }
    },
    {
        key: 'parentId',
        label: 'label.em.spareparts.emSppLocation.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emSppLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'warehouseKeeper',
        label: 'label.em.spareparts.emSppLocation.entity.warehouseKeeper',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'seq',
        label: 'label.em.spareparts.emSppLocation.entity.seq',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.spareparts.emSppLocation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
]

export {
    EmSppLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
